import React from 'react'
import CurrencyFormat from "react-currency-format";
import {const_var } from "../../../redux/reducers/reducer";

function SideJTrimPrice() {
  const extraItems = const_var?.post_data?.building?.extra_items;
  const sideJTrimPrice =  extraItems?.find(item => item.item_name === "Jtrim");

  return (

    <div className='price-box-type-2'>    
      {((const_var.loginSession == false && const_var.hide_price_calculation != 1 && const_var.post_data.building!=undefined && const_var.post_data.building.extra_items.length>0 && sideJTrimPrice!=undefined &&sideJTrimPrice.item_price>0)) &&
            <CurrencyFormat value = {sideJTrimPrice.item_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
          }
    </div>
  )
}

export default SideJTrimPrice